import { ActionButton, ActionButtonType, Callout } from "@octopusdeploy/design-system-components";
import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import styles from "./style.module.less";
type ChangeStepPackageVersionCalloutProps = {
    highestAvailableMajorVersion: number;
    currentMajorVersion: number;
    previousMajorVersion?: number;
    releaseNotesHref?: string;
    error?: string;
    inProgress: boolean;
    onUpgradeClick: () => void;
    onCancelClick: () => void;
};
export function ChangeStepPackageVersionCallout({ highestAvailableMajorVersion, currentMajorVersion, previousMajorVersion, releaseNotesHref, inProgress, error, onUpgradeClick, onCancelClick }: ChangeStepPackageVersionCalloutProps) {
    const variants = {
        upgradeAvailable: {
            title: `Version ${highestAvailableMajorVersion} of this step is available. You are currently on version ${currentMajorVersion}. `,
            copy: "Additional information may be required. ",
            buttonLabel: "Upgrade",
            clickHandler: onUpgradeClick,
            calloutType: "information",
            buttonType: ActionButtonType.Secondary,
            releaseNotesHref,
        } as const,
        inProgress: {
            title: `Step ${previousMajorVersion && previousMajorVersion < currentMajorVersion ? "upgraded" : "changed"} to version ${currentMajorVersion}. `,
            copy: `To complete the ${previousMajorVersion && previousMajorVersion < currentMajorVersion ? "upgrade" : "change"} click Save (or click Cancel to switch back). `,
            buttonLabel: "Cancel",
            clickHandler: onCancelClick,
            calloutType: "success",
            buttonType: ActionButtonType.Ternary,
            releaseNotesHref,
        } as const,
        error: {
            title: `Something went wrong.`,
            copy: `${error} `,
            buttonLabel: "Cancel",
            clickHandler: onCancelClick,
            calloutType: "danger",
            buttonType: ActionButtonType.Ternary,
            releaseNotesHref: null,
        } as const,
    };
    function getVariant(inProgress: boolean, error?: string) {
        if (error) {
            return variants.error;
        }
        if (inProgress) {
            return variants.inProgress;
        }
        return variants.upgradeAvailable;
    }
    const variant = getVariant(inProgress, error);
    return (<Callout title={variant.title} type={variant.calloutType}>
            <div className={styles.content}>
                <div className={styles.copy}>
                    {variant.copy}
                    {variant.releaseNotesHref && (<ExternalLink href={variant.releaseNotesHref} showIcon={false} aria-label="Release Notes">
                            What's new
                        </ExternalLink>)}
                </div>
                <div className={styles.button}>
                    <ActionButton label={variant.buttonLabel} onClick={variant.clickHandler} type={variant.buttonType}/>
                </div>
            </div>
        </Callout>);
}
